"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSmartPricingStats = void 0;
const helpers_1 = require("../view/pages/tasks/pricing/helpers");
/**
 * Calculate the smart pricing recap given a valid smart pricing recommendations
 * If for some reason the data is not valid, return null
 * @param smartPricingData
 * @param pricingDefaults
 * @param pricingOverrides
 * @return ISmartPricingCalculatedData
 */
const calculateSmartPricingStats = (smartPricingData, pricingDefaults, pricingOverrides) => {
    if (!smartPricingData || smartPricingData.length === 0 || !pricingDefaults)
        return null;
    let highestPrice = -Infinity;
    let avgPriceSum = 0;
    let lowestPrice = Infinity;
    let count = 0;
    let peakMonth = '';
    let lowestMonth = '';
    let pricingUntil = '';
    // We convert an array of price overrides to an object keyed by date:
    // this avoids exponential (O) time due to having to iterate thorough all overrides each time.
    const mappedPricingOverrides = {};
    if (pricingOverrides && pricingOverrides.length > 0) {
        pricingOverrides.forEach((pricingOverride) => {
            if (!pricingOverride.price)
                return;
            mappedPricingOverrides[pricingOverride.effective_date] = pricingOverride.price;
        });
    }
    smartPricingData.forEach((dailyPrice) => {
        try {
            // If the price is below the minimum price then we have to use the minimum.
            let minimumPrice = Math.max((0, helpers_1.fromFloyd)(dailyPrice.price), (0, helpers_1.fromFloyd)(pricingDefaults.min_price));
            // If there is an override and is above the minimum price then we use that one
            if (mappedPricingOverrides[dailyPrice.date]
                && (0, helpers_1.fromFloyd)(mappedPricingOverrides[dailyPrice.date]) > (0, helpers_1.fromFloyd)(pricingDefaults.min_price)) {
                minimumPrice = (0, helpers_1.fromFloyd)(mappedPricingOverrides[dailyPrice.date]);
            }
            if (minimumPrice >= highestPrice) {
                highestPrice = minimumPrice;
                peakMonth = dailyPrice.date;
            }
            if (minimumPrice <= lowestPrice) {
                lowestPrice = minimumPrice;
                lowestMonth = dailyPrice.date;
            }
            avgPriceSum += minimumPrice;
            pricingUntil = dailyPrice.date;
            count++;
        }
        catch (error) {
            console.error('Error calculating smart pricing stats, so skipping this recommendation for: ', error);
        }
    });
    // This will only happen if all the data is somehow dirty and there is no valid recommendation
    if (count === 0)
        return null;
    const avgPrice = Math.round(avgPriceSum / count);
    return {
        highest_price: highestPrice,
        average_price: avgPrice,
        lowest_price: lowestPrice,
        peak_month: peakMonth,
        lowest_month: lowestMonth,
        pricing_until: pricingUntil
    };
};
exports.calculateSmartPricingStats = calculateSmartPricingStats;
//# sourceMappingURL=pricing_helpers.js.map